export class MaintenanceActivitiesModel {
  maintenanceActivitiesId: number = 0;
  companyId: number = 0;
  code: number = 0;
  alterCode: string | null = null;
  description: string = '';
  createDate: Date = new Date();
  userNameCreate: string = '';
  updateDate: Date | null = null;
  userNameUpdate: string | null = null;
}